module.exports = __webpack_public_path__ + "static/img/m_default_avatar.d21b537.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/images/m_default_avatar.jpg
// module id = plwk
// module chunks = 80